<template>
  <div class="absolute w-full h-full flex">
    <div className="animate-spin h-48 w-48 border-8 border-blue-500 rounded-full border-t-transparent m-auto"></div>
  </div>
</template>
